export const COOKIE_POLICY_CONTENT = `
## 1. ¿Qué son las cookies?

Las cookies son pequeños archivos de texto que un sitio web almacena en tu dispositivo (ordenador, móvil, tablet) cuando lo visitas. Permiten recordar preferencias, mantener sesiones activas o recopilar información estadística.

También utilizamos tecnologías similares, como el almacenamiento local del navegador (localStorage), para recordar tus preferencias de consentimiento.

## 2. ¿Quién utiliza las cookies en este sitio?

| Concepto | Dato |
| --- | --- |
| Titular | Alejandro Serrano Notivoli |
| NIF | ES29133706C |
| Correo electrónico | soporte@alejandrosn.com |
| Sitio web | https://blunticle.alejandrosn.com |

## 3. Tipos de cookies que utilizamos

### Cookies técnicas (necesarias)

Son imprescindibles para el funcionamiento del sitio. No requieren consentimiento.

| Nombre | Tipo | Finalidad | Duración |
| --- | --- | --- | --- |
| Cookie JWT (sesión) | Cookie HttpOnly | Mantener la sesión de usuario autenticado | Sesión / expiración del token |
| cookie-consent | localStorage | Recordar tu elección sobre cookies analíticas | Hasta que la borres manualmente |

### Cookies analíticas (opcionales)

Solo se activan si aceptas expresamente en el banner de cookies.

| Nombre | Proveedor | Finalidad | Duración |
| --- | --- | --- | --- |
| _ga | Google Analytics | Distinguir usuarios únicos | 2 años |
| _ga_* | Google Analytics | Mantener estado de la sesión analítica | 2 años |

### Servicios de terceros

| Servicio | Tipo | Finalidad | Más información |
| --- | --- | --- | --- |
| Google Fonts | Recurso externo | Cargar tipografía Plus Jakarta Sans | [Política de Google](https://policies.google.com/privacy) |
| Stripe | Cookie de tercero (solo en checkout) | Procesar pagos de forma segura | [Política de Stripe](https://stripe.com/privacy) |

## 4. Cómo gestionar tus preferencias

Al visitar Blunticle por primera vez, verás un banner con dos opciones:

- **Aceptar todas:** activa cookies analíticas (Google Analytics).
- **Solo necesarias:** solo cookies técnicas imprescindibles.

Puedes cambiar tu decisión en cualquier momento borrando el almacenamiento local de tu navegador para este sitio y recargando la página. El banner volverá a mostrarse.

También puedes configurar tu navegador para bloquear o eliminar cookies. Ten en cuenta que bloquear las cookies técnicas impedirá el inicio de sesión.

## 5. Más información

Para cualquier consulta sobre el uso de cookies, escríbenos a soporte@alejandrosn.com.

Consulta también nuestra [Política de Privacidad](/politica-privacidad).
`;
